import { useCallback, useEffect } from 'react';
import { useModalActions } from 'components/ModalManager/Context';
import { noop } from 'utils/fp';
import { GRPCClientProvider, grpcClient } from 'api/grpc/client';
import { BatchPredictModal } from './BatchPredictModal';

export function useBatchPredictModal({ closeOnUnmount = false }: { closeOnUnmount?: boolean }): {
  open: () => void;
  close: () => void;
} {
  const actions = useModalActions();
  // TODO: fix types
  const closeBatchPredictArea = useCallback(() => {
    actions.closeModal({
      id: 'batch-predict',
    });
  }, [actions]);

  const openBatchPredictArea = useCallback(() => {
    actions.openModal({
      title: '',
      content: (
        <GRPCClientProvider client={grpcClient}>
          <BatchPredictModal closeBatchPredictArea={closeBatchPredictArea} />
        </GRPCClientProvider>
      ),
      id: 'batch-predict', // unique modal id
      makeActions: noop, // disable default "Close" modal action
      showBackdrop: true,
      closeOnBackdropClick: false,
      hideOnEsc: false,
    });
  }, [actions]);

  // close modal on unmount if open
  useEffect(() => {
    return closeOnUnmount ? () => closeBatchPredictArea() : () => null;
  }, [closeOnUnmount]);
  return { open: openBatchPredictArea, close: closeBatchPredictArea };
}
